var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"x-small":"","fab":"","icon":"","text":""},on:{"click":_vm.removeRow}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }